import { getTestIds } from 'seagull/utils/TestIds';
export const GetNotificationSettingsTableV2TID = (parentTestId)=>getTestIds(parentTestId);
